import React from 'react';
import { inject, observer } from 'mobx-react';
import AppLayout from 'layouts/AppLayout';
import Wrapper from 'components/Wrapper';
import ContentWrapper from 'components/ContentWrapper';
import Container from 'components/Container';
import SupervisorOrdersList from 'components/SupervisorOrdersList';
import MainTopWrapper from '../../components/MainTopWrapper';
import Heading from '../../components/Heading';

import { SUPERVISOR_ORDER_LIST } from '../../api';
import styles from './styles.module.scss';

class SupervisorOrdersPage extends React.Component {
    constructor(props) {
        super(props);
        this.store = props.store;
        this.state = {
            title: 'Заказы моих сотрудников',
            data: [],
            isLoading: true,
        };
    }

    componentDidMount() {
        document.title = this.state.title;
        SUPERVISOR_ORDER_LIST().then(({ data }) => {
            this.setState({ data: data.orders, isLoading: false });
        });
    }

    render() {
        return (
            <AppLayout
                userName={this.store.profile.getUserNameField('navbar')}
                companyCode={this.store.app.companyCode}
            >
                <Wrapper>
                    <MainTopWrapper
                        profile={this.store.profile}
                    />
                    <ContentWrapper isLoading={this.state.isLoading}>
                        <Container>
                            <Heading className={styles.OrdersListHeading} level="4">{'Заказы моих сотрудников'}</Heading>
                            <SupervisorOrdersList
                                data={this.state.data}/>
                        </Container>
                    </ContentWrapper>
                </Wrapper>
            </AppLayout>
        );
    }
}

export default inject('store')(observer(SupervisorOrdersPage));
